import React, { CSSProperties } from "react";

interface CustomButtonProps {
  btnName?: React.ReactNode;
  onClick?: () => void;
  customClasses?: string;
  disabledProp?: boolean;
  style?: CSSProperties;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  btnName = "Custom Button",
  onClick,
  customClasses = "",
  disabledProp = false,
  style = {},
}) => {
  return (
    <button
      disabled={disabledProp}
      onClick={onClick}
      className={`block rounded-md ${customClasses}`}
      style={{
        background: disabledProp ? "#9ca3af" : "#2D7DEF",
        color: "#fff",
        padding: "8px 20px",
        border: "none",
        cursor: disabledProp ? "not-allowed" : "pointer",
        ...style,
      }}
    >
      {btnName}
    </button>
  );
};

export default CustomButton;
